import { __decorate, __metadata } from "tslib";
import { Type } from "class-transformer";
import { EntrySearchOptionsModel, IEntrySearchOptionsDTO } from "./entrySearchOptionsDTO";
let EntrySelectionRequestModel = /** @class */ (() => {
    var _a;
    class EntrySelectionRequestModel {
        constructor() {
            this.isAllSelected = false;
            this.entries = [];
            this.searchParams = new EntrySearchOptionsModel();
        }
    }
    __decorate([
        Type(() => EntrySearchOptionsModel),
        __metadata("design:type", typeof (_a = typeof IEntrySearchOptionsDTO !== "undefined" && IEntrySearchOptionsDTO) === "function" ? _a : Object)
    ], EntrySelectionRequestModel.prototype, "searchParams", void 0);
    return EntrySelectionRequestModel;
})();
export { EntrySelectionRequestModel };
export default class EntryReport extends EntrySelectionRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
